<template>
  <div class="order-recovery-view">
    <!-- TODO: Add feedback form -->
  </div>
</template>
<script setup>
import { onMounted } from 'vue';
import { useTitle } from '@vueuse/core';
import { useRoute, useRouter } from 'vue-router';
// eslint-disable-next-line import/no-cycle
import useApiHelpers from '@/composables/api/helpers';
import appConstants from '@/composables/helpers/appConstants';
import useErrorHandling from '@/composables/api/useErrorHandling';

import { useGlobalStore } from '@/stores/globalStore';

const { postRequest } = useApiHelpers();
const route = useRoute();
const router = useRouter();
const globalStore = useGlobalStore();
const { handleErrorInSpaFlow } = useErrorHandling();

onMounted(async () => {
  useTitle('Sad to see you go');

  const { orderId } = route.params;

  try {
    await postRequest('/order/event/', {
      order_id: orderId,
      event: 'order_recovery_opt_out',
    });
    if (globalStore.getMerchantSettings?.allowDirectVisit) {
      router.push('/');
    } else {
      const { name, returnUrl } = globalStore.getMerchantSettings;
      const errorHtml = `<p>
          To place an order with Banxa on ${name}, please<br />
          visit ${name}'s
          <a href="${returnUrl}" rel="noopener noreferrer">Buy Crypto</a>
          page directly.<br />
        </p>

        <p>
          Do you have any questions?
          <br />
          Our friendly 24/7 support team are always happy to
          <nobr>assist you.</nobr>
          <br />
          Simply reach out to us under:
          <a
            rel="noopener noreferrer"
            style="text-decoration: underline"
            href=mailto:${appConstants.SUPPORT_EMAIL}
            >${appConstants.SUPPORT_EMAIL}</a
          >
        </p>`;

      handleErrorInSpaFlow('dontAllowDirectVisit', errorHtml);
    }
  } catch (err) {
    console.log(err);
  }
});

</script>
<style lang="scss" scoped>
.order-recovery-view {
  height: 100vh;
}
</style>
